import { isTridentInIframe } from '../../shared/utils/iframe.utils';
import { Metamodel } from '../base/model';
import { ServiceNowObjectDataset } from '../dataset/servicenow.dataset';
import { ModelConstants } from '../model-constants';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: ModelConstants.serviceNowCopySource,
    disabled: isTridentInIframe(),
    display: [],
    tags: { datasetModel: Metamodel.modelFor(ServiceNowObjectDataset) }
})
export class ServiceNowCopySource extends TabularCopySource {
}
